import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/** Persisted view-mode for the Finance → Commissions list (mirrors invoices). */
export type CommissionsViewMode = 'table' | 'list' | 'cards' | 'grouped';

interface CommissionsUiState {
  view: CommissionsViewMode;
  setView: (view: CommissionsViewMode) => void;
  /** DRF `OrderingFilter` value (e.g. `-won_date`). Session-only. */
  ordering: string | undefined;
  setOrdering: (ordering: string | undefined) => void;
}

export const useCommissionsUi = create<CommissionsUiState>()(
  persist(
    (set) => ({
      view: 'table',
      setView: (view) => set({ view }),
      ordering: undefined,
      setOrdering: (ordering) => set({ ordering }),
    }),
    {
      name: 'finance.commissions:ui',
      partialize: (state) => ({ view: state.view }),
    },
  ),
);
